module.exports = __webpack_public_path__ + "static/media/material_bg.abe4a318.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/Images/material_bg.png
// module id = 584
// module chunks = 5